export const base_url = "https://freetrail-staging.wordaddin.compugrade.com"
// export const base_url = "https://dassadas.fsdfafs.ai"

// export const base_url = "https://37cf448022a4.ngrok-free.app"

export const admin_dashbaord_base_url = "https://staging-api.dashboard.compugrade.com"

export const classroom_archive_password = "OSBlFwv5ouUd5H24"
